export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/index/resources/computed.js